var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('transition',{attrs:{"name":"fade","appear":"","appear-active-class":"fade-enter-active"}},[_c('EmployeeComponent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }